import { createContext, useContext, useEffect, useState } from 'react';

import { getAllBP } from '../services/baseplateService';
import { getAllKapton } from '../services/kaptonService';
import { getAllTape } from '../services/tapeService';
import { getAllGlues } from '../services/glueService';
import { getAllMaterial } from '../services/materialService';
import { getAllUsers } from '../services/userService';
import { getAllShipments } from '../services/shipmentService';
import { getAllInbound } from '../services/inboundService';
import { AuthContext } from "./Login/AuthContext"
import { getAllRemote } from '../services/remoteService';

export const DatabaseContext = createContext({
  // The read-only items to the database state
  baseplateList: {},
  kaptonList: {},
  tapeList: {},
  glueList: {},
  materialList: {},
  userList: {},
  shipmentList: {},
  inboundList: {},
  remoteList: {},
  // Updating the items from a database call
  updateBaseplateList: async () => { },
  updateKaptonList: async () => { },
  updateTapeList: async () => { },
  updateGlueList: async () => { },
  updateMaterialList: async () => { },
  updateUserList: async () => { },
  updateShipmentList: async () => { },
  updateInboundList: async () => { },
  updateRemoteList: async () => { },
  // Simple alias function for updating everything
  updateAllLists: () => { }
});

export const DBProvider = ({ children }) => {
  const { authToken } = useContext(AuthContext);
  // Actual items
  const [baseplateList, setBaseplateList] = useState({});
  const [kaptonList, setKaptonList] = useState({});
  const [tapeList, setTapeList] = useState({});
  const [glueList, setGlueList] = useState({});
  const [materialList, setMaterialList] = useState({});
  const [userList, setUserList] = useState({});
  const [shipmentList, setShipmentList] = useState({});
  const [inboundList, setInboundList] = useState({});
  const [remoteList, setRemoteList] = useState({});

  const updateBaseplateList = async () => {
    getAllBP().then((bpList) => setBaseplateList(bpList));
  }

  const updateKaptonList = async () => {
    getAllKapton().then((kapList) => setKaptonList(kapList));
  }

  const updateTapeList = async () => {
    getAllTape().then((tapList) => setTapeList(tapList));
  }

  const updateGlueList = async () => {
    getAllGlues().then((gList) => setGlueList(gList));
  }

  const updateMaterialList = async () => {
    getAllMaterial().then((matList) => setMaterialList(matList))
  }

  const updateUserList = async () => {
    getAllUsers().then((uList) => setUserList(uList))
  }

  const updateShipmentList = async () => {
    getAllShipments().then((shipList) => setShipmentList(shipList))
  }

  const updateInboundList = async () => {
    getAllInbound().then((inList) => setInboundList(inList))
  }

  const updateRemoteList = async () => {
    getAllRemote().then((inRemote) => setRemoteList(inRemote))
  }

  const updateAllLists = () => {
    updateKaptonList();
    updateTapeList();
    updateGlueList();
    updateMaterialList();
    updateShipmentList();
    updateInboundList();
    updateRemoteList();
    updateBaseplateList(); // Always update baseplate last, as it requires all other tables to fully function
    if (authToken) {
      updateUserList();
    }
  }

  // Update the context immediately upon loading the database
  // eslint-disable-next-line
  useEffect(updateAllLists, []);

  return <DatabaseContext.Provider value={{
    baseplateList, kaptonList, tapeList, glueList, materialList, userList, shipmentList, inboundList, remoteList,
    updateBaseplateList, updateKaptonList, updateTapeList, updateGlueList, updateMaterialList, updateUserList, updateShipmentList, updateInboundList, updateRemoteList,
    updateAllLists
  }}>
    {children}
  </DatabaseContext.Provider>
}


export default DatabaseContext;
